import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWordsWithRelatedWordsGet } from '@shared/dto/+word/word_with_related_words/_requests/request_words_with_related_words_get';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { StateWords } from '../state_words';

export const remote_word_with_related_words_get = createAsyncThunkSafe<void, RequestWordsWithRelatedWordsGet>(
  ENUM__network_event_client_to_server.WORD_WITH_WORDS_RELATED_GET,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORD_WITH_WORDS_RELATED_GET, request);
  },
);

export function init_remote_word_with_related_words_get(builder: ActionReducerMapBuilder<StateWords>) {
  builder
    .addCase(remote_word_with_related_words_get.pending, (state, action) => {})
    .addCase(remote_word_with_related_words_get.rejected, (state, action) => {})
    .addCase(remote_word_with_related_words_get.fulfilled, (state, action: PayloadAction) => {});
}
